/*
 Sticky-kit v1.1.2 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
*/
;(function () {
  var b, f
  b = this.jQuery || window.jQuery
  f = b(window)
  b.fn.stick_in_parent = function (d) {
    var A, w, J, n, B, K, p, q, k, E, t
    null == d && (d = {})
    t = d.sticky_class
    B = d.inner_scrolling
    E = d.recalc_every
    k = d.parent
    q = d.offset_top
    p = d.spacer
    w = d.bottoming
    null == q && (q = 0)
    null == k && (k = void 0)
    null == B && (B = !0)
    null == t && (t = "is_stuck")
    A = b(document)
    null == w && (w = !0)
    J = function (a, d, n, C, F, u, r, G) {
      var v, H, m, D, I, c, g, x, y, z, h, l
      if (!a.data("sticky_kit")) {
        a.data("sticky_kit", !0)
        I = A.height()
        g = a.parent()
        null != k && (g = g.closest(k))
        if (!g.length) throw "failed to find stick parent"
        v = m = !1
        ;(h = null != p ? p && a.closest(p) : b("<div />")) && h.css("position", a.css("position"))
        x = function () {
          var c, f, e
          if (
            !G &&
            ((I = A.height()),
            (c = parseInt(g.css("border-top-width"), 10)),
            (f = parseInt(g.css("padding-top"), 10)),
            (d = parseInt(g.css("padding-bottom"), 10)),
            (n = g.offset().top + c + f),
            (C = g.height()),
            m &&
              ((v = m = !1),
              null == p && (a.insertAfter(h), h.detach()),
              a.css({ position: "", top: "", width: "", bottom: "" }).removeClass(t),
              (e = !0)),
            (F = a.offset().top - (parseInt(a.css("margin-top"), 10) || 0) - q),
            (u = a.outerHeight(!0)),
            (r = a.css("float")),
            h &&
              h.css({
                width: a.outerWidth(!0),
                height: u,
                display: a.css("display"),
                "vertical-align": a.css("vertical-align"),
                float: r
              }),
            e)
          )
            return l()
        }
        x()
        if (u !== C)
          return (
            (D = void 0),
            (c = q),
            (z = E),
            (l = function () {
              var b, l, e, k
              if (
                !G &&
                ((e = !1),
                null != z && (--z, 0 >= z && ((z = E), x(), (e = !0))),
                e || A.height() === I || x(),
                (e = f.scrollTop()),
                null != D && (l = e - D),
                (D = e),
                m
                  ? (w &&
                      ((k = e + u + c > C + n),
                      v &&
                        !k &&
                        ((v = !1),
                        a
                          .css({ position: "fixed", bottom: "", top: c })
                          .trigger("sticky_kit:unbottom"))),
                    e < F &&
                      ((m = !1),
                      (c = q),
                      null == p &&
                        (("left" !== r && "right" !== r) || a.insertAfter(h), h.detach()),
                      (b = { position: "", width: "", top: "" }),
                      a.css(b).removeClass(t).trigger("sticky_kit:unstick")),
                    B &&
                      ((b = f.height()),
                      u + q > b &&
                        !v &&
                        ((c -= l),
                        (c = Math.max(b - u, c)),
                        (c = Math.min(q, c)),
                        m && a.css({ top: c + "px" }))))
                  : e > F &&
                    ((m = !0),
                    (b = { position: "fixed", top: c }),
                    (b.width =
                      "border-box" === a.css("box-sizing")
                        ? a.outerWidth() + "px"
                        : a.width() + "px"),
                    a.css(b).addClass(t),
                    null == p && (a.after(h), ("left" !== r && "right" !== r) || h.append(a)),
                    a.trigger("sticky_kit:stick")),
                m && w && (null == k && (k = e + u + c > C + n), !v && k))
              )
                return (
                  (v = !0),
                  "static" === g.css("position") && g.css({ position: "relative" }),
                  a
                    .css({ position: "absolute", bottom: d, top: "auto" })
                    .trigger("sticky_kit:bottom")
                )
            }),
            (y = function () {
              x()
              return l()
            }),
            (H = function () {
              G = !0
              f.off("touchmove", l)
              f.off("scroll", l)
              f.off("resize", y)
              b(document.body).off("sticky_kit:recalc", y)
              a.off("sticky_kit:detach", H)
              a.removeData("sticky_kit")
              a.css({ position: "", bottom: "", top: "", width: "" })
              g.position("position", "")
              if (m)
                return (
                  null == p && (("left" !== r && "right" !== r) || a.insertAfter(h), h.remove()),
                  a.removeClass(t)
                )
            }),
            f.on("touchmove", l),
            f.on("scroll", l),
            f.on("resize", y),
            b(document.body).on("sticky_kit:recalc", y),
            a.on("sticky_kit:detach", H),
            setTimeout(l, 0)
          )
      }
    }
    n = 0
    for (K = this.length; n < K; n++) (d = this[n]), J(b(d))
    return this
  }
}).call(this)
/*
 ddslick
*/
;(function (e) {
  e.fn.ddslick = function (l) {
    if (c[l]) {
      return c[l].apply(this, Array.prototype.slice.call(arguments, 1))
    } else {
      if (typeof l === "object" || !l) {
        return c.init.apply(this, arguments)
      } else {
        e.error("Method " + l + " does not exists.")
      }
    }
  }
  var c = {},
    d = {
      data: [],
      keepJSONItemsOnTop: false,
      width: 260,
      height: null,
      background: "#eee",
      selectText: "",
      defaultSelectedIndex: null,
      truncateDescription: true,
      imagePosition: "left",
      showSelectedHTML: true,
      clickOffToClose: true,
      embedCSS: true,
      onSelected: function () {}
    },
    i =
      '<div class="dd-select"><input class="dd-selected-value" type="hidden" /><a class="dd-selected"></a><span class="dd-pointer dd-pointer-down"></span></div>',
    a = '<ul class="dd-options"></ul>',
    b =
      '<style id="css-ddslick" type="text/css">.dd-select{ border-radius:2px; border:solid 1px #ccc; position:relative; cursor:pointer;}.dd-desc { color:#aaa; display:block; overflow: hidden; font-weight:normal; line-height: 1.4em; }.dd-selected{ overflow:hidden; display:block; padding:10px; font-weight:bold;}.dd-pointer{ width:0; height:0; position:absolute; right:10px; top:50%; margin-top:-3px;}.dd-pointer-down{ border:solid 5px transparent; border-top:solid 5px #000; }.dd-pointer-up{border:solid 5px transparent !important; border-bottom:solid 5px #000 !important; margin-top:-8px;}.dd-options{ border:solid 1px #ccc; border-top:none; list-style:none; box-shadow:0px 1px 5px #ddd; display:none; position:absolute; z-index:2000; margin:0; padding:0;background:#fff; overflow:auto;}.dd-option{ padding:10px; display:block; border-bottom:solid 1px #ddd; overflow:hidden; text-decoration:none; color:#333; cursor:pointer;-webkit-transition: all 0.25s ease-in-out; -moz-transition: all 0.25s ease-in-out;-o-transition: all 0.25s ease-in-out;-ms-transition: all 0.25s ease-in-out; }.dd-options > li:last-child > .dd-option{ border-bottom:none;}.dd-option:hover{ background:#f3f3f3; color:#000;}.dd-selected-description-truncated { text-overflow: ellipsis; white-space:nowrap; }.dd-option-selected { background:#f6f6f6; }.dd-option-image, .dd-selected-image { vertical-align:middle; float:left; margin-right:5px; max-width:64px;}.dd-image-right { float:right; margin-right:15px; margin-left:5px;}.dd-container{ position:relative;}​ .dd-selected-text { font-weight:bold}​</style>'
  c.init = function (l) {
    var l = e.extend({}, d, l)
    if (e("#css-ddslick").length <= 0 && l.embedCSS) {
      e(b).appendTo("head")
    }
    return this.each(function () {
      var p = e(this),
        q = p.data("ddslick")
      if (!q) {
        var n = [],
          o = l.data
        p.find("option").each(function () {
          var w = e(this),
            v = w.data()
          n.push({
            text: e.trim(w.text()),
            value: w.val(),
            selected: w.is(":selected"),
            description: v.description,
            imageSrc: v.imagesrc
          })
        })
        if (l.keepJSONItemsOnTop) {
          e.merge(l.data, n)
        } else {
          l.data = e.merge(n, l.data)
        }
        var m = p,
          s = e('<div id="' + p.attr("id") + '"></div>')
        p.replaceWith(s)
        p = s
        p.addClass("dd-container").append(i).append(a)
        var n = p.find(".dd-select"),
          u = p.find(".dd-options")
        u.css({ width: l.width })
        n.css({ width: l.width, background: l.background })
        p.css({ width: l.width })
        if (l.height != null) {
          u.css({ height: l.height, overflow: "auto" })
        }
        e.each(l.data, function (v, w) {
          if (w.selected) {
            l.defaultSelectedIndex = v
          }
          u.append(
            '<li><a class="dd-option">' +
              (w.value
                ? ' <input class="dd-option-value" type="hidden" value="' + w.value + '" />'
                : "") +
              (w.imageSrc
                ? ' <img class="dd-option-image' +
                  (l.imagePosition == "right" ? " dd-image-right" : "") +
                  '" src="' +
                  w.imageSrc +
                  '" />'
                : "") +
              (w.text ? ' <label class="dd-option-text">' + w.text + "</label>" : "") +
              (w.description
                ? ' <small class="dd-option-description dd-desc">' + w.description + "</small>"
                : "") +
              "</a></li>"
          )
        })
        var t = {
          settings: l,
          original: m,
          selectedIndex: -1,
          selectedItem: null,
          selectedData: null
        }
        p.data("ddslick", t)
        if (l.selectText.length > 0 && l.defaultSelectedIndex == null) {
          p.find(".dd-selected").html(l.selectText)
        } else {
          var r =
            l.defaultSelectedIndex != null &&
            l.defaultSelectedIndex >= 0 &&
            l.defaultSelectedIndex < l.data.length
              ? l.defaultSelectedIndex
              : 0
          j(p, r)
        }
        p.find(".dd-select").on("click.ddslick", function () {
          f(p)
        })
        p.find(".dd-option").on("click.ddslick", function () {
          j(p, e(this).closest("li").index())
        })
        if (l.clickOffToClose) {
          u.addClass("dd-click-off-close")
          p.on("click.ddslick", function (v) {
            v.stopPropagation()
          })
          e("body").on("click", function () {
            e(".dd-click-off-close")
              .slideUp(50)
              .siblings(".dd-select")
              .find(".dd-pointer")
              .removeClass("dd-pointer-up")
          })
        }
      }
    })
  }
  c.select = function (l) {
    return this.each(function () {
      if (l.index !== undefined) {
        j(e(this), l.index)
      }
    })
  }
  c.open = function () {
    return this.each(function () {
      var m = e(this),
        l = m.data("ddslick")
      if (l) {
        f(m)
      }
    })
  }
  c.close = function () {
    return this.each(function () {
      var m = e(this),
        l = m.data("ddslick")
      if (l) {
        k(m)
      }
    })
  }
  c.destroy = function () {
    return this.each(function () {
      var n = e(this),
        m = n.data("ddslick")
      if (m) {
        var l = m.original
        n.removeData("ddslick").unbind(".ddslick").replaceWith(l)
      }
    })
  }
  function j(q, s) {
    var u = q.data("ddslick")
    var r = q.find(".dd-selected"),
      n = r.siblings(".dd-selected-value"),
      v = q.find(".dd-options"),
      l = r.siblings(".dd-pointer"),
      p = q.find(".dd-option").eq(s),
      m = p.closest("li"),
      o = u.settings,
      t = u.settings.data[s]
    q.find(".dd-option").removeClass("dd-option-selected")
    p.addClass("dd-option-selected")
    u.selectedIndex = s
    u.selectedItem = m
    u.selectedData = t
    if (o.showSelectedHTML) {
      r.html(
        (t.imageSrc
          ? '<img class="dd-selected-image' +
            (o.imagePosition == "right" ? " dd-image-right" : "") +
            '" src="' +
            t.imageSrc +
            '" />'
          : "") +
          (t.text ? '<label class="dd-selected-text">' + t.text + "</label>" : "") +
          (t.description
            ? '<small class="dd-selected-description dd-desc' +
              (o.truncateDescription ? " dd-selected-description-truncated" : "") +
              '" >' +
              t.description +
              "</small>"
            : "")
      )
    } else {
      r.html(t.text)
    }
    n.val(t.value)
    u.original.val(t.value)
    q.data("ddslick", u)
    k(q)
    g(q)
    if (typeof o.onSelected == "function") {
      o.onSelected.call(this, u)
    }
  }
  function f(p) {
    var o = p.find(".dd-select"),
      m = o.siblings(".dd-options"),
      l = o.find(".dd-pointer"),
      n = m.is(":visible")
    e(".dd-click-off-close").not(m).slideUp(50)
    e(".dd-pointer").removeClass("dd-pointer-up")
    if (n) {
      m.slideUp("fast")
      l.removeClass("dd-pointer-up")
    } else {
      m.slideDown("fast")
      l.addClass("dd-pointer-up")
    }
    h(p)
  }
  function k(l) {
    l.find(".dd-options").slideUp(50)
    l.find(".dd-pointer").removeClass("dd-pointer-up").removeClass("dd-pointer-up")
  }
  function g(o) {
    var n = o.find(".dd-select").css("height")
    var m = o.find(".dd-selected-description")
    var l = o.find(".dd-selected-image")
    if (m.length <= 0 && l.length > 0) {
      o.find(".dd-selected-text").css("lineHeight", n)
    }
  }
  function h(l) {
    l.find(".dd-option").each(function () {
      var p = e(this)
      var n = p.css("height")
      var o = p.find(".dd-option-description")
      var m = l.find(".dd-option-image")
      if (o.length <= 0 && m.length > 0) {
        p.find(".dd-option-text").css("lineHeight", n)
      }
    })
  }
})(jQuery)

/* =====
Ajaxinate version v2.0.11 https://github.com/Elkfox/Ajaxinate Copyright (c) 2017 Elkfox Co Pty Ltd https://elkfox.com MIT License
================================================================================================= */
;("use strict")
var Ajaxinate = function (t) {
  var e = t || {}
  ;(this.settings = Object.assign(
    {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: "Loading",
      callback: null
    },
    e
  )),
    (this.addScrollListeners = this.addScrollListeners.bind(this)),
    (this.addClickListener = this.addClickListener.bind(this)),
    (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
    (this.stopMultipleClicks = this.stopMultipleClicks.bind(this)),
    (this.destroy = this.destroy.bind(this)),
    (this.containerElement = document.querySelector(this.settings.container)),
    (this.paginationElement = document.querySelector(this.settings.pagination)),
    this.initialize()
}
;(Ajaxinate.prototype.initialize = function () {
  this.containerElement &&
    { click: this.addClickListener, scroll: this.addScrollListeners }[this.settings.method]()
}),
  (Ajaxinate.prototype.addScrollListeners = function () {
    this.paginationElement &&
      (document.addEventListener("scroll", this.checkIfPaginationInView),
      window.addEventListener("resize", this.checkIfPaginationInView),
      window.addEventListener("orientationchange", this.checkIfPaginationInView))
  }),
  (Ajaxinate.prototype.addClickListener = function () {
    this.paginationElement &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      (this.clickActive = !0),
      null !== this.nextPageLinkElement &&
        this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks))
  }),
  (Ajaxinate.prototype.stopMultipleClicks = function (t) {
    t.preventDefault(),
      this.clickActive &&
        ((this.nextPageLinkElement.innerHTML = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        (this.clickActive = !1),
        this.loadMore())
  }),
  (Ajaxinate.prototype.checkIfPaginationInView = function () {
    var t = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
      e = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset
    t <= window.innerHeight &&
      e >= 0 &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      this.removeScrollListener(),
      this.nextPageLinkElement &&
        ((this.nextPageLinkElement.innerHTML = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        this.loadMore()))
  }),
  (Ajaxinate.prototype.loadMore = function () {
    ;(this.request = new XMLHttpRequest()),
      (this.request.onreadystatechange = function () {
        if (4 === this.request.readyState && 200 === this.request.status) {
          var t = this.request.responseXML.querySelectorAll(this.settings.container)[0],
            e = this.request.responseXML.querySelectorAll(this.settings.pagination)[0]
          this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
            (this.paginationElement.innerHTML = e.innerHTML),
            this.settings.callback &&
              "function" == typeof this.settings.callback &&
              this.settings.callback(this.request.responseXML),
            this.initialize()
        }
      }.bind(this)),
      this.request.open("GET", this.nextPageUrl),
      (this.request.responseType = "document"),
      this.request.send()
  }),
  (Ajaxinate.prototype.removeClickListener = function () {
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks)
  }),
  (Ajaxinate.prototype.removeScrollListener = function () {
    document.removeEventListener("scroll", this.checkIfPaginationInView),
      window.removeEventListener("resize", this.checkIfPaginationInView),
      window.removeEventListener("orientationchange", this.checkIfPaginationInView)
  }),
  (Ajaxinate.prototype.destroy = function () {
    return (
      { click: this.removeClickListener, scroll: this.removeScrollListener }[
        this.settings.method
      ](),
      this
    )
  })
